/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import {RouterProvider} from 'react-router-dom'
import {VmoToastContainer} from 'vmo-library'
import withToast from 'components/hoc/withToast'
import appRoutes from 'navigation/AppRoutes'
import { generateIntegrityHash } from 'utils/helper'
  
function App() {


  // Function to dynamically add integrity to all script and link tags on page load

  const addIntegrityToResources = async () => {
    // Find all script and link tags on the page
    const resources = [
      ...document.querySelectorAll('script[src]'),
      ...document.querySelectorAll('link[href]'),
    ]

    for (const resource of resources) {
      const isScript = resource.tagName === 'SCRIPT'
      const isLink = resource.tagName === 'LINK'

      if (isScript && !resource.hasAttribute('integrity')) {
        const url = resource.src
        const integrity = await generateIntegrityHash(url) // Wait for hash generation
        if (integrity) {
          resource.integrity = integrity
          resource.crossOrigin = 'anonymous'
        }
      }

      if (isLink && !resource.hasAttribute('integrity')) {
        const url = resource.href
        const integrity = await generateIntegrityHash(url) // Wait for hash generation
        if (integrity) {
          resource.integrity = integrity
          resource.crossOrigin = 'anonymous'
        }
      }
    }
  }

  // Simulated function to generate integrity hash for a URL (replace with actual logic)

  // Call the function to add integrity attributes on page load
  useEffect(() => {
    addIntegrityToResources()
  }, [])

  return (
    <>
      <VmoToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
      />
      <RouterProvider router={appRoutes} />
    </>
  )
}
export default withToast(App)
